import React, { useEffect, useState, useRef } from "react"
import valuer_api from "../../../api/valuer"

const SPECIAL_UPLOAD_ID = -1

const DropDownSelector = ({ onChange, defaultId }) => {
    const [templates, setTemplates] = useState([])
    const [selectedId, setSelectedId] = useState(null)
    const [isOpen, setIsOpen] = useState(false)
    const dropdownRef = useRef(null)

    useEffect(() => {
        valuer_api.getYamlTemplateNames()
            .then(response => {
                let list = response.data
                if (!list.some(t => t.id === SPECIAL_UPLOAD_ID)) {
                    list.push({ id: SPECIAL_UPLOAD_ID, display_name: "Other PDF report" })
                }

                setTemplates(list)

                const ids = list.map(t => t.id)
                const fallbackId = (defaultId != null && ids.includes(defaultId))
                    ? defaultId
                    : ids.length > 1
                        ? ids.find(id => id !== SPECIAL_UPLOAD_ID)
                        : SPECIAL_UPLOAD_ID

                setSelectedId(fallbackId)
                onChange(fallbackId)
            })
            .catch(err => {
                console.error("Failed to fetch templates", err)
                const fallback = { id: SPECIAL_UPLOAD_ID, display_name: "Other PDF report" }
                setTemplates([fallback])
                setSelectedId(SPECIAL_UPLOAD_ID)
                onChange(SPECIAL_UPLOAD_ID)
            })
    }, [defaultId])

    const handleSelect = (id) => {
        setSelectedId(id)
        onChange(id)
        setIsOpen(false)
    }

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [])

    const selectedLabel = templates.find(t => t.id === selectedId)?.display_name || "Select template"

    return (
        <div className="dropdown-wrapper" ref={dropdownRef}>
            <div className="dropdown-selected" onClick={() => setIsOpen(!isOpen)}>
                {selectedLabel}
                <span className="dropdown-arrow">▼</span>
            </div>
            {isOpen && (
                <ul className="dropdown-options">
                    {templates.map(tpl => (
                        <li
                            key={tpl.id}
                            className={`dropdown-option ${tpl.id === selectedId ? "selected" : ""}`}
                            onClick={() => handleSelect(tpl.id)}
                        >
                            {tpl.display_name}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default DropDownSelector
